import { twMerge } from "tailwind-merge";

interface FormInputProps {
  name: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  placeholder: string;
  error?: string;
  isTextArea?: boolean;
}

const FormInput = ({ 
  name, 
  type, 
  value, 
  onChange, 
  placeholder, 
  error, 
  isTextArea = false 
}: FormInputProps) => {
  const baseClasses = `
    text-dark w-full rounded-lg border-none bg-white text-base font-medium
    leading-normal outline-none placeholder:text-[#afafaf] focus:border-none focus:ring-0
  `;

  const inputProps = {
    name,
    type,
    value,
    onChange,
    placeholder,
    className: twMerge(baseClasses, error && "border-red-500 border-2")
  };

  return (
    <div className="flex flex-col gap-y-1">
      {isTextArea ? (
        <textarea 
          {...inputProps} 
          className={twMerge(inputProps.className, "h-[187px]")}
        />
      ) : (
        <input {...inputProps} />
      )}
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </div>
  );
};

export default FormInput; 